import { forwardRef, ReactNode } from "react";

import { cx } from "@/utils";

import styles from "../Base.module.css";

export interface InputProps extends React.HTMLProps<HTMLInputElement> {
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
  block?: boolean;
  error?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      error = false,
      className,
      block,
      startAdornment = null,
      endAdornment = null,
      disabled,
      ...props
    },
    ref
  ) => {
    return (
      <span
        className={cx(styles.control, { [styles.block]: block }, className)}
      >
        {startAdornment}
        <input
          ref={ref}
          disabled={disabled}
          aria-invalid={error}
          aria-disabled={disabled}
          className={cx(styles.root, {
            [styles.adornedStart]: startAdornment !== null,
            [styles.adornedEnd]: endAdornment !== null,
          })}
          {...props}
        />
        {endAdornment}
      </span>
    );
  }
);

Input.displayName = "Input";

export default Input;
